import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ConstantsService} from "../../../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-information-modal',
  templateUrl: './information-modal.component.pug',
  styleUrls: ['./information-modal.component.scss'],
  standalone: false
})
export class InformationModalComponent implements OnInit {

  @Input() checkType = 'reference';
  referenceType = ConstantsService.REFERENCE_CHECK;
  exitType = ConstantsService.EXIT_CHECK;
  backgroundType = ConstantsService.BACKGROUND_CHECK;
  pulseType = ConstantsService.PULSE_CHECK;

  constructor(public _bsModalRef: BsModalRef, private permissionService: PermissionsService) {
  }

  ngOnInit(): void {
  }

  cancel() {
    this._bsModalRef.hide();
  }

}
